module.exports = __webpack_public_path__ + "assets/img/watermark.b464f5ef.svg";